import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setShowBanner } from "@/redux/actions/dynamicContent";
import {
  RideGlError,
  RideGlRight,
  RideIconButton,
} from "@rimac-seguros/ride-system-components";
import useBreakpoint from "@/hooks/useBreakpoint";
import { analytics } from "@/components/organisms/BannerCampaign";
import "./styles.scss";

export const ButtonBanner = ({
  activeBtnClose,
  activeBtnGo,
  customClassBtnGo,
}) => {
  const { dynamicContent, nameCampaign } = useSelector(
    (state) => state.dynamicContent
  );
  const content = dynamicContent[0]?.venta_digital_cintillo || {};

  const dispatch = useDispatch();

  const isDesktop = useBreakpoint("large-min");
  return (
    <>
      {activeBtnClose && (
        <div
          onClick={() => {
            dispatch(setShowBanner(false));
            analytics(content?.name_product ?? "", nameCampaign, "Cerrar");
          }}
        >
          <RideGlError
            size={isDesktop ? "large" : "medium"}
            fill="#FFFFFF"
            className="button-close"
          />
        </div>
      )}
      {activeBtnGo && (
        <RideIconButton
          glyph={<RideGlRight />}
          variant="fill-inverse"
          className={`${customClassBtnGo}`}
        />
      )}
    </>
  );
};
